module.exports = __webpack_public_path__ + "img/实时接入@3x.29e47c54.png";